import React from 'react';
import { Box, Paper, Typography, Button, Stack } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { getApiBaseUrl } from '../../../utils/apiBaseUrl';

const API_URL = getApiBaseUrl();

const normalizeBaseUrl = (url) => (url || '').replace(/\/$/, '');

const CheckinClosed = () => {
  const [searchParams] = useSearchParams();
  const slug = searchParams.get('slug') || '';
  const retryUrl = slug
    ? `${normalizeBaseUrl(API_URL)}/checkin/${encodeURIComponent(slug)}`
    : null;

  const handleRetry = () => {
    if (retryUrl) {
      window.location.href = retryUrl;
      return;
    }
    window.location.reload();
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    window.location.href = '/';
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#F0E6DC',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 4,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: '100%',
          maxWidth: 640,
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
        }}
      >
        <Typography
          variant="overline"
          sx={{ color: '#FF2D54', fontWeight: 700, letterSpacing: 2 }}
        >
          Clube de Mesa
        </Typography>
        <Typography variant="h5" fontWeight="bold" sx={{ mt: 1 }}>
          Check-in indisponível
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1.5 }}>
          O check-in só pode ser feito durante o horário de funcionamento do restaurante.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 3 }}>
          <Button
            variant="contained"
            onClick={handleRetry}
            sx={{
              bgcolor: '#FF2D54',
              '&:hover': { bgcolor: '#e0264a' },
            }}
          >
            Tentar novamente
          </Button>
          <Button
            variant="outlined"
            onClick={handleBack}
            sx={{
              borderColor: '#FF2D54',
              color: '#FF2D54',
              '&:hover': { borderColor: '#e0264a', color: '#e0264a' },
            }}
          >
            Voltar
          </Button>
        </Stack>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
          Se você acredita que isso é um engano, fale com o restaurante.
        </Typography>
      </Paper>
    </Box>
  );
};

export default CheckinClosed;
